import {list} from '@/domain/comitentes/services';
import parse from '../../tiposbem/parse';

const searchComitente = function () {
  let window = 'windowComitenteSearch'
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Buscar Comitente',
    width: '800',
    height: '600',
    minHeight: '500',
    backdrop: true,
    clickOutside: false,
    windowClass: 'erp-window',
    contentClass: 'overflow-hidden bg-white',
    props: {
      columns: [
        {label: 'ID', value: 'id'},
        {label: 'Nome', value: 'nome'},
        // {
        //   label: 'Tipos', value: (v) => {
        //     return parse(v)
        //   }
        // }
      ],
      fetchData: (terms, filters, done) => {
        let rowsPerPage = 100
        let ad = ''
        if (this.tipo) {
          ad = ad + '&tipo=' + (this.tipo.id ?? this.tipo)
        }
        list(rowsPerPage, filters.page, '&sortBy=id&descending=desc&search=' + terms + ad)
          .then(({data}) => {
            let result = data.result.map(obj => ({
              ...obj,
              nome: obj.pessoa.name,
            }))
            let filter = function (terms, {field, list}) {
              const token = terms.toLowerCase()
              return list.filter(item => ('' + item[field]).toLowerCase().includes(token))
            }

            let filteredData = filter(terms, {field: 'nome', list: result})

            done(filteredData, {
              page: filters.page,
              rowsNumber: data.total, // response.totalRows,
              rowsPerPage: rowsPerPage
            })
          })
          .catch((error) => {
            console.error(error)
          })
      }
    }
  }, () => import('../../../../layout/window/WindowSearch.vue'))
    .then((wid) => {
      this.$uloc.window.listen(wid, {
        selected: (wid, val) => {
          console.log('Selecionado com sucesso: ', val)
          this.findedData = val
          this.model = val.id
          this.__emit(val.id)
          this.description = val.id + ' - ' + val.nome
          setTimeout(() => {
            this.$refs.input && this.$refs.input.focus()
          }, 200)
        }
      })
      console.log(wid)
    }) // return wid
}

export default searchComitente
